import * as Actions from '../Actions/MeusConvitesActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    dialog: null
};

const MeusConvitesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_MEUSCONVITES:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.MEUSCONVITES_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.MEUSCONVITES_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.MEUSCONVITES_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = MeusConvitesReducer;
export default reducer;
